import * as React from 'react';
import './index.less'
import './assets/iconfont.css';

interface YdyIconYypes {
  /** 内置 icon 名称 */
  type: string
  /** 图标大小 */
  size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg'
  /** 图标颜色 */
  color?: string
  onClick?: (event) => void
}

class YdyIcon extends React.Component<YdyIconYypes, any> {
  render () {
    return (
      <i style={{color: this.props.color || '#3296FA'}} 
        className={`ydy-icon ydy-icon-${this.props.size || 'sm'} dingtalk antd-${this.props.type} `}
        onClick={this.props.onClick}
      ></i>
    );
  }
}

export default YdyIcon;


// WEBPACK FOOTER //
// ./src/components/YdyIcon/index.tsx